import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M7.02926 2.55904L8.41177 1.17653C8.52483 1.0635 8.67816 1 8.83804 1C8.99791 1 9.15124 1.0635 9.26431 1.17653L10.8235 2.73569C10.9365 2.84876 11 3.00209 11 3.16196C11 3.32184 10.9365 3.47517 10.8235 3.58823L9.44096 4.97074M7.02926 2.55904L1.17666 8.41164C1.06358 8.52468 1.00003 8.67802 1 8.83791V10.3971C1 10.557 1.06352 10.7103 1.17659 10.8234C1.28966 10.9365 1.44302 11 1.60293 11H3.16209C3.32199 11 3.47532 10.9364 3.58836 10.8233L9.44096 4.97074M7.02926 2.55904L9.44096 4.97074",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
